module.exports = __webpack_public_path__ + "img/海麻雀.29449a17.jpg";